<template>
    <Authenticated>
        <template #header>
            <PageTitle translationKey="opportunities.title"/>
            <Tabs @switchTab="switchTab" :tabs="tabs" classes="hidden lg:flex" />
            <DropdownTabs @switchTab="switchTab" :activeTab="getActiveTab()" :tabs="tabs" classes="block lg:hidden" />
        </template>

        <CreateOpportunityForm />
    </Authenticated>
</template>

<script>
import PageTitle from "@/Components/PageTitle";
import CreateOpportunityForm from "@/Components/Opportunities/Forms/Create";
import Tabs from '@/Components/Tabs';
import DropdownTabs from '@/Components/DropdownTabs';
import { Inertia } from '@inertiajs/inertia';
import Authenticated from '@/Layouts/Authenticated';

export default {
    components: {
        Authenticated,
        Tabs,
        CreateOpportunityForm,
        PageTitle,
        DropdownTabs,
    },
    data: () => ({
        tabs: {},
    }),
    methods: {
        switchTab(key) {
            if( this.tabs[key].route ) {
                Inertia.visit( route(this.tabs[key].route) );
                return;
            }

            Object.keys(this.tabs).forEach(key => this.tabs[key].active = false);
            this.tabs[key].active = true;
        },
        getActiveTab() {
            return Object.keys(this.tabs).find(key => this.tabs[key].active === true);
        },
    },
    created() {
        this.tabs = {
            "all-opportunities": {
                translationKey: "opportunities.overview.all-opportunities",
                active: false,
                route: this.$page.props.locale + '.opportunities'
            },
            "create-opportunity": {
                translationKey: "opportunities.overview.add-opportunity",
                active: true,
            }
        }
    }
}
</script>
